import * as React from 'react';
import { Label } from 'office-ui-fabric-react/lib/Label';
import { observer } from 'mobx-react';
import { OwaDate } from 'owa-datetime';
import { DropdownDatePicker } from 'owa-datepicker';
import TimePicker from 'owa-timepicker/lib/components/TimePicker';

const styles = require('./AutomaticRepliesDateTimePicker.scss');

export interface AutomaticRepliesDateTimePickerProps {
    pickerStyle: string;
    labelStyle: string;
    labelText: string;
    date: OwaDate;
    dateSelected: (date: OwaDate) => void;
    dateAriaLabel: string;
    onTimeChanged: (date: OwaDate) => void;
    timeAriaLabel: string;
    isEnabled?: boolean;
}

@observer
export default class AutomaticRepliesDateTimePicker extends React.Component<
    AutomaticRepliesDateTimePickerProps
> {
    render() {
        return (
            <div className={this.props.pickerStyle}>
                <Label className={this.props.labelStyle} disabled={!this.props.isEnabled}>
                    {this.props.labelText}
                </Label>
                <DropdownDatePicker
                    className={styles.datePicker}
                    disabled={!this.props.isEnabled}
                    value={this.props.date}
                    onSelectDate={this.props.dateSelected}
                    ariaLabel={this.props.dateAriaLabel}
                />
                <TimePicker
                    className={styles.timePicker}
                    selectedTime={this.props.date}
                    onChanged={this.props.onTimeChanged}
                    ariaLabel={this.props.timeAriaLabel}
                    readOnly={!this.props.isEnabled}
                />
            </div>
        );
    }
}
